<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div id="exhibitor-edit-tab-account">
    <div class="tab-top-part">
      <!-- Avatar Row -->
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-5">
            <!-- <h3>Session Type - {{session_data.SessionTypeDetails.TypeName}}</h3> -->
            <div class="custom-head-wrap">
                <!-- <h2 class="cms-custom-heading">Session Type - {{sessionType.label}}</h2>
                <p class="mt-1 mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> -->
                <input
                  type="text"
                  class="w-full" id="" v-validate="'required'" name="Exhibitor Name" placeholder="Exhibitor Name*" v-model="data_local.Name"/>
                  <span class="text-danger text-sm" v-show="errors.has('Exhibitor Name')">This field is required</span>
                  
            </div>
        </div>

        <div class="vx-col md:w-6/12 w-full mb-4">
          <div class=" border-1 image-wrap-area">
            <div class="flex items-center flex-col sm:flex-row">
              <div class="exhibitor-edit-preview-image-wrap exhibitorimage-wrap">
                <img :src="data_local.Logo" class="" />
              </div>
              <div>
                <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
                <input
                  type="file"
                  class="hidden"
                  ref="update_avatar_input"
                  @change="update_avatar($event, 'exhibitorLogo')"
                  accept="image/*"
                />
                <div class="logo-caution">
                  <vs-button class="mr-4" @click="$refs.update_avatar_input.click()"
                    >Upload</vs-button
                  >
                  <!-- <vs-button type="border" color="danger">Remove Logo</vs-button> -->
                  
                </div>
              </div>
            </div>
            <p class="reco-text-exe">
              High quality image: 2160x1080px (2:1 ratio)
            </p>
          </div>
        </div>

        <div class="vx-col md:w-3/12 w-full mt-2">
          <div class="label-top">
            <label>Email</label>
            <div class="label-info">
              <feather-icon class="" icon="InfoIcon" title="Info Icon" />
              <div class="email-label-info-msg">
                <p>
                  Attendee Business Card Exchange info will be sent to this email
                  address
                </p>
              </div>
            </div>
          </div>
          <vs-input
            class="inputx w-full"
            name="Email"
            v-model="data_local.Email"
            v-validate="'email'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{
            errors.first("Email")
          }}</span>
        </div>
        <!-- <div class="vx-col md:w-3/12 w-full mt-2">
          <label>Phone No</label>
          <vs-input
            class="inputx w-full"
            name="Phone"
            v-model="data_local.Phone"
            v-validate="'numeric'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Phone')">{{
            errors.first("Phone")
          }}</span>
        </div> -->
        <div class="vx-col md:w-3/12 w-full mt-4">
          <label>Phone</label> 
          <VuePhoneNumberInput :default-country-code="data_local.PhoneCountryCode" v-model="data_local.Phone" name="Phone" class="w-full mt-7" :preferredCountries="['US', 'GB', 'SG', 'IN']" @update="setPhoneCode" />
          <!-- <vs-input class="w-full mt-4" v-model="data_local.Phone" name="Phone" /> -->
          <span class="text-danger text-sm" v-show="errors.has('Phone')">{{
            errors.first("Phone")
          }}</span>
        </div>
      </div>
      <!-- Content Row -->
      <div class="vx-row">
        <!-- <div class="vx-col md:w-1/3 w-full mt-2">
          <label>
            Exhibitor Name
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="inputx w-full"
            name="Exhibitor Name"
            v-model="data_local.Name"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Exhibitor Name')"
            >{{ errors.first("Exhibitor Name") }}</span
          >
        </div> -->
        

        <div class="vx-col md:w-1/3 w-full mt-2">
          <div class="label-top">
            <label>Showcase Video Link(Youtube or Vimeo)</label>
            <div class="label-info">
              <feather-icon class="" icon="InfoIcon" title="Info Icon" />
              <div class="video-embed-custom-tooltip">
                <img
                  src="../../assets/images/video-embed.jpg"
                  alt="video-embed"
                />
              </div>
            </div>
          </div>
          <vs-input
            class="inputx w-full"
            name="ShowcaseVideoURL"
            v-model="data_local.ShowcaseVideoURL"
          />
        </div>

        <div class="vx-col md:w-1/3 w-full mt-2">
          <label>Booth No</label>
          <vs-input
            class="inputx w-full"
            name="BoothNo"
            v-model="data_local.BoothNo"
          />
        </div>

        <div class="vx-col md:w-1/3 w-full mt-2">
          <label>Website</label>
          <vs-input
            class="inputx w-full"
            name="Website"
            v-validate="'url:require_protocol'"
            v-model="data_local.Website"
          />
          <span class="text-danger text-sm" v-show="errors.has('Website')">{{
            errors.first("Website")
          }}</span>
        </div>

        <div
          class="vx-col md:w-1/3 w-full mt-2"
          v-if="data_local.ariealView == true"
        >
          <label>Display Order</label>
          <vs-input
            class="inputx w-full"
            name="displayOrder"
            v-model="displaySeq"
          />
        </div>

        <div class="vx-col md:w-1/3 w-full mt-2">
          <label>Select Template Style</label>
          <!-- <vs-input class="inputx w-full" name="Category" v-model="data_local.Category"/> -->
          <!-- <v-select
            multiple
            :closeOnSelect="false"
            v-model="exhCategory"
            label="Category"
            :options="CategoryData"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />-->
          <v-select
            class
            v-model="exhCategory"
            label="Category"
            :options="CategoryData"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>

        <div class="vx-col md:w-8/12 w-full mt-2">
          <label>Mapped Contacts</label>
          <v-select
            multiple
            :closeOnSelect="false"
            v-model="data_local.MappedContacts"
            label="Name"
            :options="attendessList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>      
        <div class="vx-col md:w-8/12 w-full mt-2">
          <label>Contact Admins</label>
          <v-select
            multiple
            :closeOnSelect="false"
            v-model="ContactAdmins"
            label="Name"
            :reduce="item => item.AttendeeId"
            :options="data_local.MappedContacts"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <div class="vx-col md:w-6/12 w-full mt-2">
          <label>Select Exhibitor Type(Optional)</label>
          <div class="hotspot-imagelink-box-wrap">
            <v-select
            class="md:w-11/12"
            placeholder="select type"
            :options="exhibitorTypes"
            label="TypeName"
            v-model="data_local.Type"
          />
            <vs-button
              color="primary"
              type="filled"
              @click="popupAddType=true"
              size="small"
              class="ml-3"
              >Add</vs-button
            >
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full mt-2">
          <label>Map with a Chat Group (Optional)</label>
          <v-select
            placeholder="Select Group"
            :options="chatGroups"
            label="name"
            v-model="data_local.mappedchatgroup"
          />
        </div>
        <div class="vx-col md:w-6/12 w-full mt-2">
          <label>Map Round Table Topic(Optional)</label>
          <v-select
            placeholder="Select Topic"
            label="TopicDisplayName"
            :options="RoundTableTopicList"
            name="RoundTableTopic"
            v-model="data_local.RoundTableTopic"
          />
        </div>
        <div class="vx-col md:w-6/12 w-full mt-2" v-if="data_local.RoundTableTopic">
          <label>Upload Round Table Topic Logo</label>
          <div class="flex items-center flex-col sm:flex-row">
            <div class="exhibitor-edit-preview-image-wrap exhibitorimage-wrap">
              <img
                v-show="data_local.RoundTableTopic.TopicLogo"
                :src="data_local.RoundTableTopic.TopicLogo"
                class="mr-2 rounded"
              />
            </div>
            <vs-input
              type="file"
              @change="update_avatar($event, 'roundTableTopicLogo')"
              accept="image/*"
            />
          </div>
        </div>
        <div class="vx-col md:w-8/12 w-full mt-2">
          <label>Profile</label>
          <!-- <vs-textarea class="inputx w-full" name="Profile" v-model="data_local.Profile" v-validate="'required'"/> -->
          <div class="profile-edit">
            <!-- <quill-editor v-model="data_local.Profile" name="Profile" /> -->
            <ckeditor
              class="desc-event"
              v-model="data_local.Profile"
              :config="editorConfig"
            ></ckeditor>
          </div>
        </div>

        <!--<div class="vx-col md:w-1/1 w-full mt-2">
          <label>Resources </label>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 my-3 ">
              <div class="upload-area-wrap">
                <input type="file" multiple class="hidden" ref="update_resource_input" @change="upload_resources" accept=".csv.excel,.xlsx,.pdf,.doc,.docx">
                <vs-button class="mr-4 mb-4" @click="$refs.update_resource_input.click()">Upload Resources</vs-button>
              </div>
            </div>
            <div class="vx-col md:w-1/2 my-3 ">
              <div class="resourse-file-list-wrap">
                <div class="single-file-wrap" v-for="file in data_local.Resources">
                  <a :href="file" class="file-sec-wrap">File</a>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="vx-col md:w-4/12 w-full mt-4">
          <div class="label-top">
            <label>Upload Hotspot Image</label>
            <div class="label-info">
              <feather-icon class="" icon="InfoIcon" title="Info Icon" />
              <div class="image-hotspot-info">
                <p>
                  Booth hotspot image should be transparent PNG file 1170 x 600px.
                  Please don't make any structural changes. Use the PSD source
                  file, you may change the colors, icons etc keeping the same
                  propotions. This is to ensure the file is compatible with the
                  hotspot zones in the template.
                </p>
              </div>
            </div>
          </div>
          <div class="hotspot-imagelink-box-wrap">
            <vs-input
              class="inputx w-full"
              name="HotspotImageURL"
              v-model="data_local.HotspotImageURL"
            />
            <vs-button
              color="primary"
              type="filled"
              @click="$refs.upload_image.click()"
              size="small"
              class="upload-btn"
              >Upload</vs-button
            >
          </div>
          <div class="hotspot-image-box-wrapper">
            <img
              v-show="data_local.HotspotImageURL"
              :src="data_local.HotspotImageURL"
              class="mr-2 rounded"
            />
          </div>
          <input
            class="hidden"
            ref="upload_image"
            type="file"
            @change="UploadImage($event, 'HotspotImageURL', 'HotspotImageURL')"
            accept="image/*"
          />
        </div>
      </div>

      <!-- <div class="countDivder vx-col md:w-1/1 w-full">
          <vs-divider> Social Links </vs-divider>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-4">
            <label>Facebook</label>
            <div class="mt-2">
              <vs-input class="inputx w-full" name="Facebook" v-model="data_local.SocialLinks.Facebook"/>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
            <label>Twitter</label>
            <div class="mt-2">
              <vs-input class="inputx w-full" name="Twitter" v-model="data_local.SocialLinks.Twitter"/>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
            <label>GooglePlus</label>
            <div class="mt-2">
              <vs-input class="inputx w-full" name="GooglePlus" v-model="data_local.SocialLinks.GooglePlus"/>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
            <label>LinkedIn</label>
            <div class="mt-2">
              <vs-input class="inputx w-full" name="LinkedIn" v-model="data_local.SocialLinks.LinkedIn"/>
            </div>
        </div>
      </div>-->
    </div>
    <div class="tab-botttom-sticky-part">
      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="mt-2" @click="$router.push('/event/exhibitors')"
              >Back To List</vs-button
            >
            <vs-button
              class="ml-auto mt-2"
              @click="before_save(true)"
              :disabled="!validateForm"
              color="success"
              >Save & Continue</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              @click="before_save(false)"
              :disabled="!validateForm"
              color="success"
              >Save & Exit</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              @click="reset_data"
              >Reset</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
    <vs-popup
      title="Add Exhibitor Type"
      :active.sync="popupAddType"
    >
      <type-form v-if="Type" :data="Type" @closePopup="popupAddType=false" />
    </vs-popup>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";

import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";
import moduleChatgroupManagement from "@/store/chatgroup-management/moduleChatgroupManagement.js";
import moduleroundtableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import TypeForm from "./TypeForm.vue";

import ls from "@/common/localStorage";
import con from "@/firebase/firebaseInit.ts";
var cn = ls.getSessionEventCollectionName();
var vm;
var count = localStorage.getItem("exhibitorCount");
export default {
  components: {
    vSelect,
    quillEditor,
    ckeditor: CKEditor.component,
    PhotowallResizeComponent,
    TypeForm,
    VuePhoneNumberInput
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    ContactAdmins: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc: this.data.Logo,
      attendessList: [],
      ResourceFiles: [],
      CategoryData: [],
      exhCategory: {
        Category: this.data.Category,
        HtmlCode: this.data.HtmlCode,
      },
      displaySeq: null,
      ariealViewUrl: null,
      editFlag: false,
      editorConfig: CKconfig.editorConfig,
      imageRatio: 2 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "2 / 1",
      uploadedFor: 'exhibitorLogo',
      uploadedFile: null,
      popupCropper: false,
      popupAddType: false,
      Type: {
          TypeId: null,
          TypeName: null,
          BackgroundImg: null
      },
      RoundTableTopicList: [],
      RoundTableTopic: null,
    };
  },
  mounted() {
    if (
      this.data_local.ariealView == true &&
      this.data_local.DisplaySequence != null
    ) {
      this.displaySeq = this.data_local.DisplaySequence;
      this.ariealViewUrl = this.data_local.AriealBoothImgURL;
      this.editFlag = true;
    } else if (this.data_local.ariealView == true) {
      this.displaySeq = localStorage.getItem("exhibitorCount");
    }
    //-----------GEt Category Listing------------------------------------------------------------------------------

    var cn = ls.getSessionEventCollectionName(); ///OA_UAT/BoothDesigns/Templates/2A1wtx9POQHMNWUlJ0PF
    var cref2 = con.eventDB
      .collection(cn)
      .doc("ExhibitorCategories")
      .collection("Category");

    cref2.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.CategoryData.push({
          Category: doc.data().Category,
          HtmlCode: doc.data().HtmlCode,
        });
      });
      //console.log(this.CategoryData);
    });
    //-----------------------------------------------------------------------------------------------------------
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
    chatGroups () {
      let chatgroups = this.$store.state.chatgroupManagement.chatgroups.map(item=>{
        return {id: item.id, name: item.name}
      });
      return chatgroups
    },
    exhibitorTypes () {
      return this.$store.state.exhibitorManagement.exhibitortypes;
    },

  },
  methods: {
    setPhoneCode(data) {
      if(data && data.formattedNumber){
        this.data_local.Phone = data.nationalNumber;
        this.data_local.PhoneCountryCode = data.countryCode;
      }      
    },
    croppedImagePath(blob) {      
      this.popupCropper = false;
      if(this.uploadedFor == 'exhibitorLogo'){
        //this.imgSrc = blob;
        this.uploadCropImage(blob, `${cn}/Exhibitor/Logo/`, this.uploadedFile);
      }
      else if(this.uploadedFor == 'roundTableTopicLogo')
        this.uploadCropImage(blob, `${cn}/RoundTableTopic/Logo/`, this.uploadedFile);
    },
    successUpload() {
      this.$vs.notify({ color: "success", title: "Successfully Uploaded" });
    },
    update_avatar(input, uploadedFor) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        this.uploadedFor = uploadedFor;
        this.uploadedFile = input.target.files[0];
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };
        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        this.data_local.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.resetCropper += 1;
          this.cropImageUrl = null;
          this.cropImageUrl = e.target.result;
          this.popupCropper = true;
         // this.imgSrc = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    upload_resources(input) {
      if (input.target.files.length) {
        for (var i = 0; i < input.target.files.length; i++) {
          const file = input.target.files[i];
          const metadata = {
            contentType: file.type,
          };
          //console.log(file)
          let filename = file.name;
          filename = filename.split(".").pop();
          //console.log(filename)
          const validImageTypes = [
            "csv",
            "pdf",
            "xlsx",
            "excel",
            "doc",
            "docx",
          ];
          if (!validImageTypes.includes(filename)) {
            alert("Only files allowed.");
            return false;
          }
          this.data_local.Resources.push(file.webkitRelativePath);
          this.ResourceFiles.push(file);
        }
      }
    },
    UploadImage(input, fieldName, fieldsrc) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 1) {
          alert("Uploaded file size exceeds 1 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          vm.uploadFile(bgImgfile, fieldName, fieldsrc);
          //this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadFile(file, fieldName, fieldsrc) {
      this.$vs.loading();
      this.$store
        .dispatch("exhibitorManagement/uploadImage", {
          file: file,
          path: cn + "/Exhibitor/Booth/",
        })
        .then((res) => {
          this.$vs.loading.close();
          this.data_local[fieldName] = res;
          if (fieldName == "AerialViewImageURL") {
            this.ariealViewUrl = res;
          }
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    uploadCropImage(fileBlob, target, file) {
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            if(this.uploadedFor == 'roundTableTopicLogo')
              this.data_local.RoundTableTopic.TopicLogo = res.data[0].value.url;
            else if(this.uploadedFor == 'exhibitorLogo')
              this.data_local.Logo = res.data[0].value.url;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Session",
            text: "Something went wrong!",
          });
        });
    },
    before_save(form_continue = false) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes(form_continue);
        }
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes(form_continue = false) {
      /* eslint-disable */
      if (!this.validateForm) return;
      //debugger;
      var errorFlg = true;
      if (this.data_local.ariealView == true && this.editFlag == false) {
        var allSequence = [];
        allSequence = localStorage.getItem("AllExhibitorDisplaySequence");
        //debugger;
        if (allSequence != null && allSequence.includes(this.displaySeq)) {
          errorFlg = false;
          alert("Display Order already exist.Please choose a new one!");
        } else {
          errorFlg = true;
        }
      }

      if (errorFlg == true) {
        this.$vs.loading();
        //this.data_local.Logo = this.imgSrc;
        this.data_local.ResourceFiles = this.ResourceFiles;
        this.ResourceFiles = [];

        const Id = this.$route.params.exhibitorId;
        //debugger;
        this.data_local.Category = this.exhCategory.Category;
        this.data_local.HtmlCode = this.exhCategory.HtmlCode;
        if (this.data_local.ariealView == true) {
          this.data_local.AriealBoothImgURL = this.ariealViewUrl;
          this.data_local.displayOrder = this.displaySeq;
        }

        if(this.data_local.MappedContacts.length){
          for(let item of this.data_local.MappedContacts){
            if(this.ContactAdmins.includes(item.AttendeeId)){
              item.IsAdmin = true
            }else{
              delete item.IsAdmin;
            }
          }
        }
        if (Id) {
          this.$store
            .dispatch("exhibitorManagement/updateExhibitor", {
              id: Id,
              data: this.data_local,
            })
            .then((res) => {
              //alert(res.message)
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Exhibitor",
                text: "Exhibitor updated successfully.",
              });
              this.displaySeq = null;
              this.$vs.loading.close();
              if (form_continue) this.$emit("activateTab", 1);
              else this.$router.push("/event/exhibitors/");
            })
            .catch((err) => {
              console.error(err);
              this.$vs.loading.close();
            });
        } else {
          this.$store
            .dispatch("exhibitorManagement/addExhibitor", {
              data: this.data_local,
            })
            .then((res) => {
              //alert(res.message)
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Exhibitor",
                text: "Exhibitor created successfully.",
              });
              this.displaySeq = null;
              this.$vs.loading.close();
              if (res.status == 200) {
                if (form_continue) {
                  this.$router.push({
                    name: "exhibitor-edit",
                    params: {
                      exhibitorId: res.Id,
                    },
                  });
                } else this.$router.push("/event/exhibitors/");
              }
            })
            .catch((err) => {
              console.error(err)
              this.$vs.loading.close();
            });
        }
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc = this.data.Logo;
    },
    //////
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        //this.attendessList = res;
        //console.log(res);
        for (let i = 0; i < res.length; i++) {
          this.attendessList.push({
            AttendeeId: res[i].AttendeeId,
            Company: res[i].Company ? res[i].Company : null,
            Designation: res[i].Designation ? res[i].Designation : null,
            Email: res[i].Email,
            FirstName: res[i].FirstName,
            LastName: res[i].LastName,
            Name: res[i].Name,
            Phone: res[i].Phone ? res[i].Phone : null,
            ProfilePictureURL: res[i].ProfilePictureURL ? res[i].ProfilePictureURL : null
          });
        }
      });
    },
    fetch_roundtabletopics() {
      this.$store
        .dispatch("roundtableManagement/fetchRoundTableTopicDropdown")
        .then((res) => {
          this.RoundTableTopicList = res;
        });
    },
  },
  created() {
    vm = this;
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }    
    if (!moduleChatgroupManagement.isRegistered) {
      this.$store.registerModule("chatgroupManagement", moduleChatgroupManagement);
      moduleChatgroupManagement.isRegistered = true;
    }
    if (!moduleroundtableManagement.isRegistered) {
      this.$store.registerModule("roundtableManagement", moduleroundtableManagement);
      moduleroundtableManagement.isRegistered = true;
    }
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    this.getAttendees();
    this.fetch_roundtabletopics();
    this.$store.dispatch("chatgroupManagement/fetchChatgroups")
    this.$store.dispatch("exhibitorManagement/fetchExhibitorTypes")
  },
};
</script>
